import { render } from "./PostFooter.vue?vue&type=template&id=30a73014"
import script from "./PostFooter.vue?vue&type=script&lang=js"
export * from "./PostFooter.vue?vue&type=script&lang=js"
script.render = render

export default script